import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { AddeditHaulerComponent } from '../addedit-hauler/addedit-hauler.component';
import { AddeditMarketComponent } from '../../markets/addedit-market/addedit-market.component';

@Component({
  selector: 'app-market-dialog',
  standalone: true,
  imports: [FormsModule, CommonModule, AddeditHaulerComponent, MatButtonModule],
  templateUrl: './hauler-dialog.component.html',
  styleUrls: ['./hauler-dialog.component.scss'],
})
export class HaulerDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<HaulerDialogComponent, any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {}
  marketFormData: any;
  ngOnInit() {
    if (!this.data || !this.data?.formData) {
    }
  }
  onNoClick(): void {
    this.dialogRef.close({ submitted: false });
  }

  onSaveClick(): void {
    this.dialogRef.close({ submitted: true, data: this.marketFormData });
  }
  onFormSubmit(data: any) {
    if (data.submit == false) {
      this.dialogRef.close({ submitted: false });
    } else {
      this.marketFormData = data;
      this.onSaveClick();
      console.log('onFormSubmit', data);
    }
  }
}
